import request from './request';

export default {
  byId: id => request.get(`/video-frame/${id}`),
  list: (offset, limit) =>
    request.get(`/video-frame?offset=${offset}&limit=${limit}&available=1`)
};
